const propsToAttributes = obj => {
  const keys = Object.keys(obj);
  return keys.reduce((acc, key) => (obj[key] ? `${acc} ${key}="${obj[key]}"` : acc), '').trim();
};

export default propsToAttributes;
